import classNames from "classnames";
import React, { CSSProperties } from "react";
import styles from "./fullWidthBase.css";

interface Props {
  containerClassName?: string;
  containerStyle?: CSSProperties;
  contentClassName?: string;
}

export const FullWidthBase = ({
  children,
  containerStyle,
  containerClassName,
  contentClassName
}: React.PropsWithChildren<Props>) => (
  <div className={classNames(styles.container, containerClassName)} style={containerStyle}>
    {children}
  </div>
);
